import React from 'react'

import Values from './../../Components/Values'
import Consultant from './../../Components/Consultant'

import Text from '../../Components/Text'

import Link from './../../Components/HeaderLink'

import './index.css'

const ContainerTabProduct = ((props)=>(
	<div className="tab__product">
		<div className="bg">
			<img src={props.bgUrl} alt={props.bgUrl} />
		</div>
		<div className="content">
			<div className="row">
				<div className="col">


				</div>
				<div className="col">
					<div className="img img--logo" style={{"backgroundImage": `url('${props.imgUrl}')`, "backgroundSize": "cover", "backgroundPosition": "center"}}>
					</div>
					<div className="content__title">
						<div>
							<div className="title" dangerouslySetInnerHTML={{__html: props.name}} />
							<div className="subtitle">{props.subtitle}</div>							
						</div>
					</div>
					<div className="values_consultant">
						<Values values={props.values} />
						{ 
							props.consultant && props.consultant ? <Consultant {...props.consultant} /> : <br/>
						}
					
					</div>
				</div>
			</div>
			<br/>
			<Text text={props.text} />
			<div className="certificates">
				<div className="title">
					{props.certificates.imgsTitle}
				</div>
				<div>
					<div className="col">
						<div className="row">
							{
								props.certificates.imgs &&  props.certificates.imgs.map((img,id)=>(
									<div className="img" key={id}>
										<img src={img.imgUrl} alt={img.id} />
									</div>
								))
							}
						</div>
					</div>
					<div className="col">
						{
							props.certificates.ask.url !== '' ? <Link text={props.certificates.ask.caption} url={props.certificates.ask.url} target={props.certificates.ask.target} className="btn btn--small" />: ''
						}
						
						{
							props.certificates.e_bill.url !== '' ? <Link text={props.certificates.e_bill.caption} url={props.certificates.e_bill.url} target={props.certificates.e_bill.target}  className="btn btn--small btn--2" />: ''
						}
						<br/>
						{
							props.certificates.link.url !== '' ? <Link text={props.certificates.link.caption} url={props.certificates.link.url} target={props.certificates.link.target}  className="btn btn--3" /> : ''
						}
						{
							props.certificates.question_link.url !== '' ? <Link text={props.certificates.question_link.caption} url={props.certificates.question_link.url} target={props.certificates.question_link.target} className="btn btn--4" />: ''
						}

					</div>
				</div>
			</div>
		</div>
	</div>
))

export default ContainerTabProduct


// WEBPACK FOOTER //
// ./src/Containers/ContainerTabProduct/index.js